import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { EmailInputComponent } from '../../form-components/email-input/email-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-member-table-email-input',
  templateUrl: '../../form-components/email-input/email-input.component.html',
  styleUrls: ['../member-table-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MemberTableEmailInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class MemberTableEmailInputComponent extends EmailInputComponent {}
